import { render, staticRenderFns } from "./KioskLanguageBar.vue?vue&type=template&id=ca244ee2&scoped=true"
import script from "./KioskLanguageBar.vue?vue&type=script&lang=js"
export * from "./KioskLanguageBar.vue?vue&type=script&lang=js"
import style0 from "./KioskLanguageBar.vue?vue&type=style&index=0&id=ca244ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca244ee2",
  null
  
)

export default component.exports